<dw-ui-dialog-box
  [title]="dialogBoxTitle"
  [headerClass]="isAntidated ? 'warning' : null"
  (saveFn)="save()"
>
  <div>
    <document-delivery-note-to-invoice-grid
      [currentDeliveryNoteId]="deliveryNoteId"
      [lines]="deliveryNotes$ | async"
      (selectionChange)="deliveryNoteSelectionChange($event)"
    >
    </document-delivery-note-to-invoice-grid>
  </div>

  <div class="mt-5">
    <document-customer-invoice-preview-grid
      [lines]="previewInvoiceLines$ | async"
      [deliveryNotes]="selectedDeliveryNotes$ | async"
    ></document-customer-invoice-preview-grid>
  </div>
</dw-ui-dialog-box>
